import * as commonScripts from '../common'
import Glide from '@glidejs/glide'
import MicroModal from 'micromodal'

const cmpDealCards = {
  component: null,
  viewport: 0,
  resizeTimer: 0,

  init: function (element) {
    const _ = this
    _.component = element
    _.viewport = commonScripts.util.getViewportSize()
    commonScripts.util.animationTranslate(this)

    MicroModal.init({
      onShow: modal => console.info(`${modal.id} is shown`),
      onClose: modal => console.info(`${modal.id} is hidden`),
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: false
    })

    const button = _.component.querySelectorAll('.modal-button')
    for (let i = 0; i < button.length; i++) {
      button[i].addEventListener('click', function () {
        MicroModal.show(button[i].id)
      })
    }

    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselDiv = _.component.querySelectorAll('.glide')
      if (carouselDiv) {
        for (let i = 0; i < carouselDiv.length; i++) {
          const autoplay = _.component.getAttribute('data-autoplay')
          let loop = _.component.getAttribute('data-loop')
          loop = loop ? loop.toLowerCase() : loop
          const options = {}
          options.gap = 30
          options.type = (loop === 'true') ? 'carousel' : 'slider'
          options.autoplay = (isNaN(autoplay) || autoplay === '0') ? false : (autoplay * 1000)
          options.rewind = false
          options.bound = true
          options.perView = 4
          options.dragThreshold = false
          options.breakpoints = {
            1024: {
              perView: 2
            },
            768: {
              perView: 1
            }
          }

          const bullets = carouselDiv[i].querySelector('.glide__bullets')
          const slideCount = carouselDiv[i].querySelectorAll('.glide__slide')

          if ((_.viewport.width > 1024 && slideCount.length < 5) || (_.viewport.width > 768 && slideCount.length < 3) || slideCount.length < 2) {
            if (bullets) {
              bullets.classList.add('hidden')
            }
          }

          new Glide(carouselDiv[i], options).mount()
        }
      }
    }
  },

  viewportSize: function (event) {
    const _ = this
    clearTimeout(_.resizeTimer)
    _.resizeTimer = setTimeout(() => {
      _.viewport = commonScripts.util.getViewportSize()
    }, 500)
  }
}

export default cmpDealCards
